/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 20 2024
 **/

import dayjs from "@/modules/init_dayjs";

/**
 * @description 서비스에서 다루고 있는 timezone을 기준으로 날짜를 생성하는 함수
 * 로컬 사용자의 timezone은 new Date로 다루세요.
 */

const RDate = dayjs.tz;
export default RDate;
